module.exports = __webpack_public_path__ + "img/55_21.75606963.png";